import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import {
  CamelOrderCouponCreateItemParams,
  CamelOrderCouponUpdateItemParams,
} from '@/pages/camel-order/coupons/create/useCamelOrderCouponItemForm';

interface Interface {
  create: (params: CamelOrderCouponCreateItemParams) => Promise<void>;
  update: (
    id: string,
    params: CamelOrderCouponUpdateItemParams
  ) => Promise<void>;
  delete: (id: string) => Promise<void>;
}

export class CamelOrderCouponService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async create(params: CamelOrderCouponCreateItemParams): Promise<void> {
    return await this.restClient.post(
      `${TABLET_API_ORIGIN}/dashboard-api/coupons` as const,
      params
    );
  }

  public async update(
    id: string,
    params: CamelOrderCouponUpdateItemParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/coupons/${id}` as const,
      params
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/coupons/${id}` as const
    );
  }
}
